module.exports = __webpack_public_path__ + "img/pecente2.d509be8c.png";